export default function additionalcalledcostitemreasons(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
        return {
            ...state,
            additionalcalledcostitemreason: action.additionalcalledcostitemreason,
        }
    case 'ADD_CURRENT_ORGANIZATION':
        return {
            ...state,
            additionalcalledcostitemreason: action.additionalcalledcostitemreason,
            organization: action.organization,
        }
    default:
        return state;
  }
}